import { IServiceSettings } from '../../../../assets/configuration';
import './css/hereandnow.css';

export const WhatIsHere = (props: { serviceSettings: IServiceSettings }) => {
    

    return (
        <div id="what" className="m-5 where-is-here-section">
            <div
                style={{
                    color: "#162242",
                    marginLeft: "10%",
                    marginRight: "10%",
                    textAlign: "center",
                }}
            >
                <h1>
                    <strong className="title-here-now">
                        About
                    </strong>
                </h1>
            </div>

            <div className="here-desc-wrap">
                <strong className="here-desc">
                    here & now is a mobile-first civic engagement platform built to help mayors and city leaders connect more
                    directly with their communities. Designed for clarity, accessibility, and trust, it brings public services,
                    information, and participation opportunities into one powerful app.
                </strong>
            </div>

            <div className="fluid-image-animation-wrapper">
                <div className="hn-image-grid">
                    {[
                        { src: `${props.serviceSettings.hostUrl}/images/public/welcome.png`, alt: "Welcome" },
                        { src: `${props.serviceSettings.hostUrl}/images/public/home.png`, alt: "Home" },
                        { src: `${props.serviceSettings.hostUrl}/images/public/news.png`, alt: "News" },
                        { src: `${props.serviceSettings.hostUrl}/images/public/communityResource.png`, alt: "Community Resources" },
                    ].map((image, index) => (
                        <div className="hn-image-grid-item" key={index}>
                            <img src={image.src} alt={`here & now ${image.alt}`} className="hn-image" />
                        </div>
                    ))}
                </div>
            </div>

        </div>

    );
};
